import { ITaskAssociationManager } from '../types/internal-types';

/**
 * Manages taskKey to taskId associations with feature scoping.
 * Uses bidirectional mapping for efficient lookups in both directions.
 */
export class TaskAssociationManager implements ITaskAssociationManager {
    private featureToKeys: Record<string, Record<string, string>> = {}; // feature -> taskKey -> taskId
    private taskIdToKey: Record<string, { feature: string; taskKey: string }> =
        {}; // taskId -> {feature, taskKey}

    setAssociation(feature: string, taskKey: string, taskId: string): void {
        // Ensure feature object exists
        if (!this.featureToKeys[feature]) {
            this.featureToKeys[feature] = {};
        }

        // Set bidirectional mapping
        this.featureToKeys[feature][taskKey] = taskId;
        this.taskIdToKey[taskId] = { feature, taskKey };
    }

    getTaskId(feature: string, taskKey: string): string | undefined {
        return this.featureToKeys[feature]?.[taskKey];
    }

    getTaskKey(taskId: string): string | undefined {
        return this.taskIdToKey[taskId]?.taskKey;
    }

    removeByTaskId(taskId: string): void {
        const keyInfo = this.taskIdToKey[taskId];
        if (keyInfo) {
            delete this.featureToKeys[keyInfo.feature]?.[keyInfo.taskKey];
            delete this.taskIdToKey[taskId];
        }
    }

    clear(): void {
        this.featureToKeys = {};
        this.taskIdToKey = {};
    }
}
